module.exports = __webpack_public_path__ + "img/wx.d27d6091.png";